/**
 * Admin pages, as a dropdown on the app bar. Rendered only for superusers; the sidebar is the same for
 * everyone and has no admin section.
 */
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Divider, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip, Typography,
} from '@mui/material';
import {
  AdminPanelSettings as AdminIcon, VerifiedUser as VerifyIcon, Report as ReportIcon,
  Analytics as AnalyticsIcon, AutoAwesome as AICreditsIcon, Sync as CallUpdatesIcon,
  PersonSearch as ProfileRemindersIcon, Campaign as AnnouncementEmailIcon, NewReleases as ReleasesIcon,
} from '@mui/icons-material';

export const ADMIN_PAGES = [
  { text: 'Verification', path: '/admin/verify-memberships/', Icon: VerifyIcon },
  { text: 'Reports', path: '/admin/reports/', Icon: ReportIcon },
  { text: 'Analytics', path: '/admin/analytics/', Icon: AnalyticsIcon },
  { text: 'AI Credits', path: '/admin/ai-credits/', Icon: AICreditsIcon },
  { text: 'Call Updates', path: '/admin/call-updates/', Icon: CallUpdatesIcon },
  { text: 'Profile Reminders', path: '/admin/profile-reminders/', Icon: ProfileRemindersIcon },
  { text: 'Announcement Emails', path: '/admin/emails/', Icon: AnnouncementEmailIcon },
  { text: 'Releases', path: '/admin/releases/', Icon: ReleasesIcon },
];

export default function AdminMenu() {
  const [anchor, setAnchor] = useState(null);
  const { pathname } = useLocation();
  const onAdminPage = pathname.startsWith('/admin/');

  return (
    <>
      <Tooltip title="Admin">
        <IconButton size="large" color="inherit" aria-label="Admin pages" aria-haspopup="true"
          aria-controls={anchor ? 'admin-menu' : undefined} onClick={(e) => setAnchor(e.currentTarget)}
          sx={{ display: 'block', ...(onAdminPage && { bgcolor: 'rgba(255,255,255,0.18)' }) }}>
          <AdminIcon />
        </IconButton>
      </Tooltip>
      <Menu id="admin-menu" anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ paper: { sx: { minWidth: 240, mt: 1 } } }}>
        <Typography variant="overline" color="text.secondary" sx={{ px: 2, display: 'block', lineHeight: 2.2 }}>Admin</Typography>
        <Divider sx={{ mb: 0.5 }} />
        {ADMIN_PAGES.map(({ text, path, Icon }) => (
          <MenuItem key={path} component={Link} to={path} selected={pathname.startsWith(path)} onClick={() => setAnchor(null)}>
            <ListItemIcon sx={{ minWidth: 36 }}><Icon sx={{ fontSize: 20 }} /></ListItemIcon>
            <ListItemText primary={text} primaryTypographyProps={{ fontSize: 14 }} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
